var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpotlightCertified = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  width: 24,
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#svg-spotlight-certified__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0277BD",
  d: "M23.998 12.002c0 .895-1.194 1.646-1.377 2.483-.193.866.56 2.068.193 2.848-.376.793-1.768.938-2.299 1.62-.535.689-.366 2.108-1.034 2.651-.667.544-1.978.063-2.754.443-.775.38-1.213 1.732-2.058 1.929-.818.192-1.796-.828-2.67-.828-.874 0-1.852 1.02-2.67.828-.846-.197-1.292-1.554-2.058-1.93-.776-.384-2.092.102-2.754-.442-.672-.548-.499-1.967-1.034-2.65-.531-.684-1.923-.828-2.299-1.622-.376-.793.386-1.982.193-2.847C1.19 13.648 0 12.897 0 12.002c0-.894 1.194-1.645 1.377-2.482.193-.866-.56-2.068-.193-2.848.367-.779 1.768-.938 2.299-1.62.535-.689.366-2.108 1.034-2.652.667-.543 1.978-.062 2.754-.442.761-.375 1.212-1.732 2.058-1.93.818-.192 1.796.828 2.67.828.874 0 1.847-1.024 2.665-.832.818.192 1.292 1.554 2.058 1.93.776.384 2.092-.102 2.755.442.662.543.498 1.967 1.034 2.65.53.683 1.922.828 2.298 1.621.376.794-.386 1.982-.193 2.848.188.837 1.377 1.588 1.377 2.482l.005.005z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F9BF17",
  d: "m17.866 16.916-8.283-5.528 2.593-5.187a.361.361 0 0 1 .647 0l5.138 10.275a.363.363 0 0 1-.09.435l-.005.005zm-8.289-5.522-2.544 5.087a.388.388 0 0 0-.033.106v-6.23c0-.296.324-.469.569-.307l2.008 1.338v.006z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F19C22",
  d: "M17.866 16.916a.36.36 0 0 1-.229.084H7.364a.36.36 0 0 1-.357-.307v-.111c0-.04.016-.073.033-.106l2.544-5.088 8.283 5.528z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-spotlight-certified__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpotlightCertified);
export default ForwardRef;